import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { paymentAPI } from '@/utils/api';
import { toast } from 'sonner';
import { trackPaymentCompleted } from '@/utils/analytics';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const dossierId = searchParams.get('dossier_id');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    confirmPayment();
  }, []);

  const confirmPayment = async () => {
    try {
      await paymentAPI.confirmPayment(sessionId, dossierId);
      toast.success('Paiement confirmé avec succès !');

      // Track successful payment
      trackPaymentCompleted(9.99, 'EUR', sessionId);
    } catch (error) {
      console.error('Payment confirmation error:', error);
      toast.error('Erreur lors de la confirmation du paiement');
    } finally {
      setLoading(false);
    }
  };

  const handleGoToStrategy = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.info('Veuillez vous reconnecter pour accéder à votre stratégie', {
        duration: 4000,
      });
      navigate(`/login?redirect=/score/${dossierId}`);
    } else {
      navigate(`/score/${dossierId}`);
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f8fafc' }}>
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => navigate('/')}
          >
            <img
              src="/logo.png"
              alt="Anti-Recouvrement.com"
              className="h-20 w-auto"
            />
          </div>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {loading ? (
          <div className="text-center">
            <div className="loader mx-auto mb-4"></div>
            <p className="text-gray-600">Confirmation du paiement...</p>
          </div>
        ) : (
          <div className="card p-8 text-center">
            <CheckCircle size={64} color="#059669" className="mx-auto mb-6" />
            <h2 className="text-3xl font-bold mb-4 text-green-800">
              Paiement réussi !
            </h2>
            <p className="text-gray-700 text-lg mb-8">
              Votre stratégie d'action personnalisée a été débloquée avec succès.
              <br />
              Vous pouvez maintenant consulter votre plan d'action complet pour maximiser vos chances d'éviter ce paiement.
            </p>
            <Button
              data-testid="go-to-dossier-button"
              size="lg"
              onClick={handleGoToStrategy}
              className="px-8 py-6 text-lg font-semibold"
              style={{ backgroundColor: '#1e3a8a', color: 'white' }}
            >
              Voir ma stratégie complète
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccessPage;